export const countries = [
  {
    "id": 1,
    "label": "United Arab Emirates",
    "countryCallingCode": "+971",
    "phoneLength": 9,
    "countryCode": "AE",
    "countryOriginFlag": "../assets/flags/ae.svg"
  },
  {
    "id": 2,
    "label": "Afghanistan",
    "countryCallingCode": "+93",
    "phoneLength": 9,
    "countryCode": "AF",
    "countryOriginFlag": "../assets/flags/af.svg"
  },
  {
    "id": 3,
    "label": "Åland Islands",
    "countryCallingCode": "+358",
    "phoneLength": 7,
    "countryCode": "AX",
    "countryOriginFlag": "../assets/flags/ax.svg"
  },
  {
    "id": 4,
    "label": "Albania",
    "countryCallingCode": "+355",
    "phoneLength": 9,
    "countryCode": "AL",
    "countryOriginFlag": "../assets/flags/al.svg"
  },
  {
    "id": 5,
    "label": "Algeria",
    "countryCallingCode": "+213",
    "phoneLength": 9,
    "countryCode": "DZ",
    "countryOriginFlag": "../assets/flags/dz.svg"
  },
  {
    "id": 6,
    "label": "American Samoa",
    "countryCallingCode": "+1684",
    "phoneLength": 11,
    "countryCode": "AS",
    "countryOriginFlag": "../assets/flags/as.svg"
  },
  {
    "id": 7,
    "label": "Andorra",
    "countryCallingCode": "+376",
    "phoneLength": 6,
    "countryCode": "AD",
    "countryOriginFlag": "../assets/flags/ad.svg"
  },
  {
    "id": 8,
    "label": "Angola",
    "countryCallingCode": "+244",
    "phoneLength": 9,
    "countryCode": "AO",
    "countryOriginFlag": "../assets/flags/ao.svg"
  },
  {
    "id": 9,
    "label": "Anguilla",
    "countryCallingCode": "+1264",
    "phoneLength": 7,
    "countryCode": "AI",
    "countryOriginFlag": "../assets/flags/ai.svg"
  },
  {
    "id": 10,
    "label": "Antarctica",
    "countryCallingCode": "+672",
    "phoneLength": 9,
    "countryCode": "AQ",
    "countryOriginFlag": "../assets/flags/aq.svg"
  },
  {
    "id": 11,
    "label": "Antigua and Barbuda",
    "countryCallingCode": "+1268",
    "phoneLength": 7,
    "countryCode": "AG",
    "countryOriginFlag": "../assets/flags/ag.svg"
  },
  {
    "id": 12,
    "label": "Argentina",
    "countryCallingCode": "+54",
    "phoneLength": 11,
    "countryCode": "AR",
    "countryOriginFlag": "../assets/flags/ar.svg"
  },
  {
    "id": 13,
    "label": "Armenia",
    "countryCallingCode": "+374",
    "phoneLength": 8,
    "countryCode": "AM",
    "countryOriginFlag": "../assets/flags/am.svg"
  },
  {
    "id": 14,
    "label": "Aruba",
    "countryCallingCode": "+297",
    "phoneLength": 7,
    "countryCode": "AW",
    "countryOriginFlag": "../assets/flags/aw.svg"
  },
  {
    "id": 15,
    "label": "Australia",
    "countryCallingCode": "+61",
    "phoneLength": 11,
    "countryCode": "AU",
    "countryOriginFlag": "../assets/flags/au.svg"
  },
  {
    "id": 16,
    "label": "Austria",
    "countryCallingCode": "+43",
    "phoneLength": 10,
    "countryCode": "AT",
    "countryOriginFlag": "../assets/flags/at.svg"
  },
  {
    "id": 17,
    "label": "Azerbaijan",
    "countryCallingCode": "+994",
    "phoneLength": 7,
    "countryCode": "AZ",
    "countryOriginFlag": "../assets/flags/az.svg"
  },
  {
    "id": 18,
    "label": "Bahrain",
    "countryCallingCode": "+973",
    "phoneLength": 8,
    "countryCode": "BH",
    "countryOriginFlag": "../assets/flags/bh.svg"
  },
  {
    "id": 19,
    "label": "Bangladesh",
    "countryCallingCode": "+880",
    "phoneLength": 10,
    "countryCode": "BD",
    "countryOriginFlag": "../assets/flags/bd.svg"
  },
  {
    "id": 20,
    "label": "Barbados",
    "countryCallingCode": "+1246",
    "phoneLength": 7,
    "countryCode": "BB",
    "countryOriginFlag": "../assets/flags/bb.svg"
  },
  {
    "id": 21,
    "label": "Belarus",
    "countryCallingCode": "+375",
    "phoneLength": 9,
    "countryCode": "BY",
    "countryOriginFlag": "../assets/flags/by.svg"
  },
  {
    "id": 22,
    "label": "Belgium",
    "countryCallingCode": "+32",
    "phoneLength": 9,
    "countryCode": "BE",
    "countryOriginFlag": "../assets/flags/be.svg"
  },
  {
    "id": 23,
    "label": "Belize",
    "countryCallingCode": "+501",
    "phoneLength": 7,
    "countryCode": "BZ",
    "countryOriginFlag": "../assets/flags/bz.svg"
  },
  {
    "id": 24,
    "label": "Benin",
    "countryCallingCode": "+229",
    "phoneLength": 10,
    "countryCode": "BJ",
    "countryOriginFlag": "../assets/flags/bj.svg"
  },
  {
    "id": 25,
    "label": "Bermuda",
    "countryCallingCode": "+1441",
    "phoneLength": 9,
    "countryCode": "BM",
    "countryOriginFlag": "../assets/flags/bm.svg"
  },
  {
    "id": 26,
    "label": "Bhutan",
    "countryCallingCode": "+975",
    "phoneLength": 7,
    "countryCode": "BT",
    "countryOriginFlag": "../assets/flags/bt.svg"
  },
  {
    "id": 27,
    "label": "Bolivia (Plurinational State of)",
    "countryCallingCode": "+591",
    "phoneLength": 8,
    "countryCode": "BO",
    "countryOriginFlag": "../assets/flags/bo.svg"
  },
  {
    "id": 28,
    "label": "Bonaire, Sint Eustatius and Saba",
    "countryCallingCode": "+5997",
    "phoneLength": 9,
    "countryCode": "BQ",
    "countryOriginFlag": "../assets/flags/bq.svg"
  },
  {
    "id": 29,
    "label": "Bosnia and Herzegovina",
    "countryCallingCode": "+387",
    "phoneLength": 8,
    "countryCode": "BA",
    "countryOriginFlag": "../assets/flags/ba.svg"
  },
  {
    "id": 30,
    "label": "Botswana",
    "countryCallingCode": "+267",
    "phoneLength": 8,
    "countryCode": "BW",
    "countryOriginFlag": "../assets/flags/bw.svg"
  },
  {
    "id": 31,
    "label": "Bouvet Island",
    "countryCallingCode": "+47",
    "phoneLength": 9,
    "countryCode": "BV",
    "countryOriginFlag": "../assets/flags/bv.svg"
  },
  {
    "id": 32,
    "label": "Brazil",
    "countryCallingCode": "+55",
    "phoneLength": 11,
    "countryCode": "BR",
    "countryOriginFlag": "../assets/flags/br.svg"
  },
  {
    "id": 33,
    "label": "British Indian Ocean Territory",
    "countryCallingCode": "+246",
    "phoneLength": 9,
    "countryCode": "IO",
    "countryOriginFlag": "../assets/flags/io.svg"
  },
  {
    "id": 34,
    "label": "Brunei Darussalam",
    "countryCallingCode": "+673",
    "phoneLength": 7,
    "countryCode": "BN",
    "countryOriginFlag": "../assets/flags/bn.svg"
  },
  {
    "id": 35,
    "label": "Bulgaria",
    "countryCallingCode": "+359",
    "phoneLength": 9,
    "countryCode": "BG",
    "countryOriginFlag": "../assets/flags/bg.svg"
  },
  {
    "id": 36,
    "label": "Burkina Faso",
    "countryCallingCode": "+226",
    "phoneLength": 8,
    "countryCode": "BF",
    "countryOriginFlag": "../assets/flags/bf.svg"
  },
  {
    "id": 37,
    "label": "Burundi",
    "countryCallingCode": "+257",
    "phoneLength": 8,
    "countryCode": "BI",
    "countryOriginFlag": "../assets/flags/bi.svg"
  },
  {
    "id": 38,
    "label": "Cabo Verde",
    "countryCallingCode": "+238",
    "phoneLength": 7,
    "countryCode": "CV",
    "countryOriginFlag": "../assets/flags/cv.svg"
  },
  {
    "id": 39,
    "label": "Cambodia",
    "countryCallingCode": "+855",
    "phoneLength": 9,
    "countryCode": "KH",
    "countryOriginFlag": "../assets/flags/kh.svg"
  },
  {
    "id": 40,
    "label": "Cameroon",
    "countryCallingCode": "+237",
    "phoneLength": 9,
    "countryCode": "CM",
    "countryOriginFlag": "../assets/flags/cm.svg"
  },
  {
    "id": 41,
    "label": "Canada",
    "countryCallingCode": "+1",
    "phoneLength": 10,
    "countryCode": "CA",
    "countryOriginFlag": "../assets/flags/ca.svg"
  },
  {
    "id": 42,
    "label": "Cayman Islands",
    "countryCallingCode": "+1345",
    "phoneLength": 10,
    "countryCode": "KY",
    "countryOriginFlag": "../assets/flags/ky.svg"
  },
  {
    "id": 43,
    "label": "Central African Republic",
    "countryCallingCode": "+236",
    "phoneLength": 8,
    "countryCode": "CF",
    "countryOriginFlag": "../assets/flags/cf.svg"
  },
  {
    "id": 44,
    "label": "Chad",
    "countryCallingCode": "+235",
    "phoneLength": 8,
    "countryCode": "TD",
    "countryOriginFlag": "../assets/flags/td.svg"
  },
  {
    "id": 45,
    "label": "Chile",
    "countryCallingCode": "+56",
    "phoneLength": 9,
    "countryCode": "CL",
    "countryOriginFlag": "../assets/flags/cl.svg"
  },
  {
    "id": 46,
    "label": "China",
    "countryCallingCode": "+86",
    "phoneLength": 11,
    "countryCode": "CN",
    "countryOriginFlag": "../assets/flags/cn.svg"
  },
  {
    "id": 47,
    "label": "Christmas Island",
    "countryCallingCode": "+61",
    "phoneLength": 9,
    "countryCode": "CX",
    "countryOriginFlag": "../assets/flags/cx.svg"
  },
  {
    "id": 48,
    "label": "Cocos (Keeling) Islands",
    "countryCallingCode": "+61891",
    "phoneLength": 9,
    "countryCode": "CC",
    "countryOriginFlag": "../assets/flags/cc.svg"
  },
  {
    "id": 49,
    "label": "Colombia",
    "countryCallingCode": "+57",
    "phoneLength": 10,
    "countryCode": "CO",
    "countryOriginFlag": "../assets/flags/co.svg"
  },
  {
    "id": 50,
    "label": "Commonwealth of The Bahamas",
    "countryCallingCode": "+1242",
    "phoneLength": 7,
    "countryCode": "BS",
    "countryOriginFlag": "../assets/flags/bs.svg"
  },
  {
    "id": 51,
    "label": "Commonwealth of the Northern Mariana Islands",
    "countryCallingCode": "+1670",
    "phoneLength": 9,
    "countryCode": "MP",
    "countryOriginFlag": "../assets/flags/mp.svg"
  },
  {
    "id": 52,
    "label": "Comoros",
    "countryCallingCode": "+269",
    "phoneLength": 7,
    "countryCode": "KM",
    "countryOriginFlag": "../assets/flags/km.svg"
  },
  {
    "id": 53,
    "label": "Cook Islands",
    "countryCallingCode": "+682",
    "phoneLength": 5,
    "countryCode": "CK",
    "countryOriginFlag": "../assets/flags/ck.svg"
  },
  {
    "id": 54,
    "label": "Costa Rica",
    "countryCallingCode": "+506",
    "phoneLength": 8,
    "countryCode": "CR",
    "countryOriginFlag": "../assets/flags/cr.svg"
  },
  {
    "id": 55,
    "label": "Côte d'Ivoire",
    "countryCallingCode": "+225",
    "phoneLength": 9,
    "countryCode": "CI",
    "countryOriginFlag": "../assets/flags/ci.svg"
  },
  {
    "id": 56,
    "label": "Croatia",
    "countryCallingCode": "+385",
    "phoneLength": 9,
    "countryCode": "HR",
    "countryOriginFlag": "../assets/flags/hr.svg"
  },
  {
    "id": 57,
    "label": "Cuba",
    "countryCallingCode": "+53",
    "phoneLength": 8,
    "countryCode": "CU",
    "countryOriginFlag": "../assets/flags/cu.svg"
  },
  {
    "id": 58,
    "label": "Curaçao",
    "countryCallingCode": "+599",
    "phoneLength": 9,
    "countryCode": "CW",
    "countryOriginFlag": "../assets/flags/cw.svg"
  },
  {
    "id": 59,
    "label": "Cyprus",
    "countryCallingCode": "+357",
    "phoneLength": 8,
    "countryCode": "CY",
    "countryOriginFlag": "../assets/flags/cy.svg"
  },
  {
    "id": 60,
    "label": "Czechia",
    "countryCallingCode": "+420",
    "phoneLength": 9,
    "countryCode": "CZ",
    "countryOriginFlag": "../assets/flags/cz.svg"
  },
  {
    "id": 61,
    "label": "Democratic Republic of the Congo",
    "countryCallingCode": "+243",
    "phoneLength": 9,
    "countryCode": "CD",
    "countryOriginFlag": "../assets/flags/cd.svg"
  },  
  {
    "id": 62,
    "label": "Denmark",
    "countryCallingCode": "+45",
    "phoneLength": 8,
    "countryCode": "DK",
    "countryOriginFlag": "../assets/flags/dk.svg"
  },
  {
    "id": 63,
    "label": "Djibouti",
    "countryCallingCode": "+253",
    "phoneLength": 8,
    "countryCode": "DJ",
    "countryOriginFlag": "../assets/flags/dj.svg"
  },
  {
    "id": 64,
    "label": "Dominica",
    "countryCallingCode": "+767",
    "phoneLength": 7,
    "countryCode": "DM",
    "countryOriginFlag": "../assets/flags/dm.svg"
  },
  {
    "id": 65,
    "label": "Dominican Republic",
    "countryCallingCode": "+1",
    "phoneLength": 9,
    "countryCode": "DO",
    "countryOriginFlag": "../assets/flags/do.svg"
  },
  {
    "id": 66,
    "label": "Ecuador",
    "countryCallingCode": "+593",
    "phoneLength": 9,
    "countryCode": "EC",
    "countryOriginFlag": "../assets/flags/ec.svg"
  },
  {
    "id": 67,
    "label": "Egypt",
    "countryCallingCode": "+20",
    "phoneLength": 10,
    "countryCode": "EG",
    "countryOriginFlag": "../assets/flags/eg.svg"
  },
  {
    "id": 68,
    "label": "El Salvador",
    "countryCallingCode": "+503",
    "phoneLength": 8,
    "countryCode": "SV",
    "countryOriginFlag": "../assets/flags/sv.svg"
  },
  {
    "id": 69,
    "label": "Equatorial Guinea",
    "countryCallingCode": "+240",
    "phoneLength": 9,
    "countryCode": "GQ",
    "countryOriginFlag": "../assets/flags/gq.svg"
  },
  {
    "id": 70,
    "label": "Eritrea",
    "countryCallingCode": "+291",
    "phoneLength": 7,
    "countryCode": "ER",
    "countryOriginFlag": "../assets/flags/er.svg"
  },
  {
    "id": 71,
    "label": "Estonia",
    "countryCallingCode": "+372",
    "phoneLength": 7,
    "countryCode": "EE",
    "countryOriginFlag": "../assets/flags/ee.svg"
  },
  {
    "id": 72,
    "label": "Eswatini",
    "countryCallingCode": "+268",
    "phoneLength": 8,
    "countryCode": "SZ",
    "countryOriginFlag": "../assets/flags/sz.svg"
  },
  {
    "id": 73,
    "label": "Ethiopia",
    "countryCallingCode": "+251",
    "phoneLength": 9,
    "countryCode": "ET",
    "countryOriginFlag": "../assets/flags/et.svg"
  },
  {
    "id": 74,
    "label": "Falkland Islands",
    "countryCallingCode": "+500",
    "phoneLength": 9,
    "countryCode": "FK",
    "countryOriginFlag": "../assets/flags/fk.svg"
  },
  {
    "id": 75,
    "label": "Faroe Islands",
    "countryCallingCode": "+298",
    "phoneLength": 8,
    "countryCode": "FO",
    "countryOriginFlag": "../assets/flags/fo.svg"
  },
  {
    "id": 76,
    "label": "Fiji",
    "countryCallingCode": "+679",
    "phoneLength": 7,
    "countryCode": "FJ",
    "countryOriginFlag": "../assets/flags/fj.svg"
  },
  {
    "id": 77,
    "label": "Finland",
    "countryCallingCode": "+358",
    "phoneLength": 9,
    "countryCode": "FI",
    "countryOriginFlag": "../assets/flags/fi.svg"
  },
  {
    "id": 78,
    "label": "France",
    "countryCallingCode": "+33",
    "phoneLength": 9,
    "countryCode": "FR",
    "countryOriginFlag": "../assets/flags/fr.svg"
  },
  {
    "id": 79,
    "label": "French Guiana",
    "countryCallingCode": "+594",
    "phoneLength": 9,
    "countryCode": "GF",
    "countryOriginFlag": "../assets/flags/gf.svg"
  },
  {
    "id": 80,
    "label": "French Polynesia",
    "countryCallingCode": "+689",
    "phoneLength": 9,
    "countryCode": "PF",
    "countryOriginFlag": "../assets/flags/pf.svg"
  },
  {
    "id": 81,
    "label": "French Southern and Antarctic Lands",
    "countryCallingCode": "+672",
    "phoneLength": 9,
    "countryCode": "TF",
    "countryOriginFlag": "../assets/flags/tf.svg"
  },
  {
    "id": 82,
    "label": "Gabon",
    "countryCallingCode": "+241",
    "phoneLength": 8,
    "countryCode": "GA",
    "countryOriginFlag": "../assets/flags/ga.svg"
  },
  {
    "id": 83,
    "label": "Gambia",
    "countryCallingCode": "+220",
    "phoneLength": 7  ,
    "countryCode": "GM",
    "countryOriginFlag": "../assets/flags/gm.svg"
  },
  {
    "id": 84,
    "label": "Georgia",
    "countryCallingCode": "+995",
    "phoneLength": 9,
    "countryCode": "GE",
    "countryOriginFlag": "../assets/flags/ge.svg"
  },
  {
    "id": 85,
    "label": "Germany",
    "countryCallingCode": "+49",
    "phoneLength": 10,
    "countryCode": "DE",
    "countryOriginFlag": "../assets/flags/de.svg"
  },
  {
    "id": 86,
    "label": "Ghana",
    "countryCallingCode": "+233",
    "phoneLength": 9,
    "countryCode": "GH",
    "countryOriginFlag": "../assets/flags/gh.svg"
  },
  {
    "id": 87,
    "label": "Gibraltar",
    "countryCallingCode": "+350",
    "phoneLength": 9,
    "countryCode": "GI",
    "countryOriginFlag": "../assets/flags/gi.svg"
  },
  {
    "id": 88,
    "label": "Greece",
    "countryCallingCode": "+30",
    "phoneLength": 10,
    "countryCode": "GR",
    "countryOriginFlag": "../assets/flags/gr.svg"
  },
  {
    "id": 89,
    "label": "Greenland",
    "countryCallingCode": "+299",
    "phoneLength": 9,
    "countryCode": "GL",
    "countryOriginFlag": "../assets/flags/gl.svg"
  },
  {
    "id": 90,
    "label": "Grenada",
    "countryCallingCode": "+1473",
    "phoneLength": 7,
    "countryCode": "GD",
    "countryOriginFlag": "../assets/flags/gd.svg"
  },
  {
    "id": 91,
    "label": "Guadeloupe",
    "countryCallingCode": "+590",
    "phoneLength": 9,
    "countryCode": "GP",
    "countryOriginFlag": "../assets/flags/gp.svg"
  },
  {
    "id": 92,
    "label": "Guam",
    "countryCallingCode": "+1",
    "phoneLength": 9,
    "countryCode": "GU",
    "countryOriginFlag": "../assets/flags/gu.svg"
  },
  {
    "id": 93,
    "label": "Guatemala",
    "countryCallingCode": "+502",
    "phoneLength": 8,
    "countryCode": "GT",
    "countryOriginFlag": "../assets/flags/gt.svg"
  },
  {
    "id": 94,
    "label": "Guernsey",
    "countryCallingCode": "+44",
    "phoneLength": 10,
    "countryCode": "GG",
    "countryOriginFlag": "../assets/flags/gg.svg"
  },
  {
    "id": 95,
    "label": "Guinea",
    "countryCallingCode": "+224",
    "phoneLength": 9,
    "countryCode": "GN",
    "countryOriginFlag": "../assets/flags/gn.svg"
  },
  {
    "id": 96,
    "label": "Guinea-Bissau",
    "countryCallingCode": "+245",
    "phoneLength": 7,
    "countryCode": "GW",
    "countryOriginFlag": "../assets/flags/gw.svg"
  },
  {
    "id": 97,
    "label": "Guyana",
    "countryCallingCode": "+592",
    "phoneLength": 7,
    "countryCode": "GY",
    "countryOriginFlag": "../assets/flags/gy.svg"
  },
  {
    "id": 98,
    "label": "Haiti",
    "countryCallingCode": "+509",
    "phoneLength": 8,
    "countryCode": "HT",
    "countryOriginFlag": "../assets/flags/ht.svg"
  },
  {
    "id": 99,
    "label": "Holy See",
    "countryCallingCode": "+39",
    "phoneLength": 10,
    "countryCode": "VA",
    "countryOriginFlag": "../assets/flags/va.svg"
  },
  {
    "id": 100,
    "label": "Honduras",
    "countryCallingCode": "+504",
    "phoneLength": 8,
    "countryCode": "HN",
    "countryOriginFlag": "../assets/flags/hn.svg"
  },
  {
    "id": 101,
    "label": "Hong Kong",
    "countryCallingCode": "+852",
    "phoneLength": 9,
    "countryCode": "HK",
    "countryOriginFlag": "../assets/flags/hk.svg"
  },
  {
    "id": 102,
    "label": "Hungary",
    "countryCallingCode": "+36",
    "phoneLength": 9,
    "countryCode": "HU",
    "countryOriginFlag": "../assets/flags/hu.svg"
  },
  {
    "id": 103,
    "label": "Iceland",
    "countryCallingCode": "+354",
    "phoneLength": 7,
    "countryCode": "IS",
    "countryOriginFlag": "../assets/flags/is.svg"
  },
  {
    "id": 104,
    "label": "India",
    "countryCallingCode": "+91",
    "phoneLength": 10,
    "countryCode": "IN",
    "countryOriginFlag": "../assets/flags/in.svg"
  },
  {
    "id": 105,
    "label": "Indonesia",
    "countryCallingCode": "+62",
    "phoneLength": 10,
    "countryCode": "ID",
    "countryOriginFlag": "../assets/flags/id.svg"
  },
  {
    "id": 106,
    "label": "Iran (Islamic Republic of)",
    "countryCallingCode": "+98",
    "phoneLength": 10,
    "countryCode": "IR",
    "countryOriginFlag": "../assets/flags/ir.svg"
  },
  {
    "id": 107,
    "label": "Iraq",
    "countryCallingCode": "+964",
    "phoneLength": 9,
    "countryCode": "IQ",
    "countryOriginFlag": "../assets/flags/iq.svg"
  },
  {
    "id": 108,
    "label": "Ireland",
    "countryCallingCode": "+353",
    "phoneLength": 9,
    "countryCode": "IE",
    "countryOriginFlag": "../assets/flags/ie.svg"
  },
  {
    "id": 109,
    "label": "Isle of Man",
    "countryCallingCode": "+44",
    "phoneLength": 10,
    "countryCode": "IM",
    "countryOriginFlag": "../assets/flags/im.svg"
  },
  {
    "id": 110,
    "label": "Israel",
    "countryCallingCode": "+972",
    "phoneLength": 9,
    "countryCode": "IL",
    "countryOriginFlag": "../assets/flags/il.svg"
  },
  {
    "id": 111,
    "label": "Italy",
    "countryCallingCode": "+39",
    "phoneLength": 9,
    "countryCode": "IT",
    "countryOriginFlag": "../assets/flags/it.svg"
  },
  {
    "id": 112,
    "label": "Jamaica",
    "countryCallingCode": "+876",
    "phoneLength": 7,
    "countryCode": "JM",
    "countryOriginFlag": "../assets/flags/jm.svg"
  },
  {
    "id": 113,
    "label": "Japan",
    "countryCallingCode": "+81",
    "phoneLength": 10,
    "countryCode": "JP",
    "countryOriginFlag": "../assets/flags/jp.svg"
  },
  {
    "id": 114,
    "label": "Jersey",
    "countryCallingCode": "+44",
    "phoneLength": 10,
    "countryCode": "JE",
    "countryOriginFlag": "../assets/flags/je.svg"
  },
  {
    "id": 115,
    "label": "Jordan",
    "countryCallingCode": "+962",
    "phoneLength": 9,
    "countryCode": "JO",
    "countryOriginFlag": "../assets/flags/jo.svg"
  },
  {
    "id": 116,
    "label": "Kazakhstan",
    "countryCallingCode": "+7",
    "phoneLength": 10,
    "countryCode": "KZ",
    "countryOriginFlag": "../assets/flags/kz.svg"
  },
  {
    "id": 117,
    "label": "Kenya",
    "countryCallingCode": "+254",
    "phoneLength": 9,
    "countryCode": "KE",
    "countryOriginFlag": "../assets/flags/ke.svg"
  },
  {
    "id": 118,
    "label": "Kiribati",
    "countryCallingCode": "+686",
    "phoneLength": 7,
    "countryCode": "KI",
    "countryOriginFlag": "../assets/flags/ki.svg"
  },
  {
    "id": 119,
    "label": "Kuwait",
    "countryCallingCode": "+965",
    "phoneLength": 8,
    "countryCode": "KW",
    "countryOriginFlag": "../assets/flags/kw.svg"
  },
  {
    "id": 120,
    "label": "Kyrgyzstan",
    "countryCallingCode": "+996",
    "phoneLength": 9,
    "countryCode": "KG",
    "countryOriginFlag": "../assets/flags/kg.svg"
  },
  {
    "id": 121,
    "label": "Lao People's Democratic Republic",
    "countryCallingCode": "+856",
    "phoneLength": 8,
    "countryCode": "LA",
    "countryOriginFlag": "../assets/flags/la.svg"
  },
  {
    "id": 122,
    "label": "Latvia",
    "countryCallingCode": "+371",
    "phoneLength": 8,
    "countryCode": "LV",
    "countryOriginFlag": "../assets/flags/lv.svg"
  },
  {
    "id": 123,
    "label": "Lebanon",
    "countryCallingCode": "+961",
    "phoneLength": 8,
    "countryCode": "LB",
    "countryOriginFlag": "../assets/flags/lb.svg"
  },
  {
    "id": 124,
    "label": "Lesotho",
    "countryCallingCode": "+266",
    "phoneLength": 8,
    "countryCode": "LS",
    "countryOriginFlag": "../assets/flags/ls.svg"
  },
  {
    "id": 125,
    "label": "Liberia",
    "countryCallingCode": "+231",
    "phoneLength": 8,
    "countryCode": "LR",
    "countryOriginFlag": "../assets/flags/lr.svg"
  },
  {
    "id": 126,
    "label": "Libya",
    "countryCallingCode": "+218",
    "phoneLength": 9,
    "countryCode": "LY",
    "countryOriginFlag": "../assets/flags/ly.svg"
  },
  {
    "id": 127,
    "label": "Liechtenstein",
    "countryCallingCode": "+423",
    "phoneLength": 7,
    "countryCode": "LI",
    "countryOriginFlag": "../assets/flags/li.svg"
  },
  {
    "id": 128,
    "label": "Lithuania",
    "countryCallingCode": "+370",
    "phoneLength": 8,
    "countryCode": "LT",
    "countryOriginFlag": "../assets/flags/lt.svg"
  },
  {
    "id": 129,
    "label": "Luxembourg",
    "countryCallingCode": "+352",
    "phoneLength": 8,
    "countryCode": "LU",
    "countryOriginFlag": "../assets/flags/lu.svg"
  },
  {
    "id": 130,
    "label": "Macao",
    "countryCallingCode": "+853",
    "phoneLength": 8,
    "countryCode": "MO",
    "countryOriginFlag": "../assets/flags/mo.svg"
  },
  {
    "id": 131,
    "label": "Madagascar",
    "countryCallingCode": "+261",
    "phoneLength": 9,
    "countryCode": "MG",
    "countryOriginFlag": "../assets/flags/mg.svg"
  },
  {
    "id": 132,
    "label": "Malawi",
    "countryCallingCode": "+265",
    "phoneLength": 9,
    "countryCode": "MW",
    "countryOriginFlag": "../assets/flags/mw.svg"
  },
  {
    "id": 133,
    "label": "Malaysia",
    "countryCallingCode": "+60",
    "phoneLength": 9,
    "countryCode": "MY",
    "countryOriginFlag": "../assets/flags/my.svg"
  },
  {
    "id": 134,
    "label": "Maldives",
    "countryCallingCode": "+960",
    "phoneLength": 7,
    "countryCode": "MV",
    "countryOriginFlag": "../assets/flags/mv.svg"
  },
  {
    "id": 135,
    "label": "Mali",
    "countryCallingCode": "+223",
    "phoneLength": 8,
    "countryCode": "ML",
    "countryOriginFlag": "../assets/flags/ml.svg"
  },
  {
    "id": 136,
    "label": "Malta",
    "countryCallingCode": "+356",
    "phoneLength": 8,
    "countryCode": "MT",
    "countryOriginFlag": "../assets/flags/mt.svg"
  },
  {
    "id": 137,
    "label": "Martinique",
    "countryCallingCode": "+596",
    "phoneLength": 9,
    "countryCode": "MQ",
    "countryOriginFlag": "../assets/flags/mq.svg"
  },

  {
    "id": 138,
    "label": "Mauritania",
    "countryCallingCode": "+222",
    "phoneLength": 8,
    "countryCode": "MR",
    "countryOriginFlag": "../assets/flags/mr.svg"
  },
  {
    "id": 139,
    "label": "Mauritius",
    "countryCallingCode": "+230",
    "phoneLength": 8,
    "countryCode": "MU",
    "countryOriginFlag": "../assets/flags/mu.svg"
  },
  {
    "id": 140,
    "label": "Mayotte",
    "countryCallingCode": "+262",
    "phoneLength": 9,
    "countryCode": "YT",
    "countryOriginFlag": "../assets/flags/yt.svg"
  },
  {
    "id": 141,
    "label": "Mexico",
    "countryCallingCode": "+52",
    "phoneLength": 11,
    "countryCode": "MX",
    "countryOriginFlag": "../assets/flags/mx.svg"
  },
  {
    "id": 142,
    "label": "Micronesia (Federated States of)",
    "countryCallingCode": "+691",
    "phoneLength": 7,
    "countryCode": "FM",
    "countryOriginFlag": "../assets/flags/fm.svg"
  },
  {
    "id": 143,
    "label": "Monaco",
    "countryCallingCode": "+377",
    "phoneLength": 8,
    "countryCode": "MC",
    "countryOriginFlag": "../assets/flags/mc.svg"
  },
  {
    "id": 144,
    "label": "Mongolia",
    "countryCallingCode": "+976",
    "phoneLength": 8,
    "countryCode": "MN",
    "countryOriginFlag": "../assets/flags/mn.svg"
  },
  {
    "id": 145,
    "label": "Montenegro",
    "countryCallingCode": "+382",
    "phoneLength": 8,
    "countryCode": "ME",
    "countryOriginFlag": "../assets/flags/me.svg"
  },
  {
    "id": 146,
    "label": "Montserrat",
    "countryCallingCode": "+1664",
    "phoneLength": 9,
    "countryCode": "MS",
    "countryOriginFlag": "../assets/flags/ms.svg"
  },
  {
    "id": 147,
    "label": "Morocco",
    "countryCallingCode": "+212",
    "phoneLength": 9,
    "countryCode": "MA",
    "countryOriginFlag": "../assets/flags/ma.svg"
  },
  {
    "id": 148,
    "label": "Mozambique",
    "countryCallingCode": "+258",
    "phoneLength": 9,
    "countryCode": "MZ",
    "countryOriginFlag": "../assets/flags/mz.svg"
  },
  {
    "id": 149,
    "label": "Myanmar",
    "countryCallingCode": "+95",
    "phoneLength": 9,
    "countryCode": "MM",
    "countryOriginFlag": "../assets/flags/mm.svg"
  },
  {
    "id": 150,
    "label": "Namibia",
    "countryCallingCode": "+264",
    "phoneLength": 9,
    "countryCode": "NA",
    "countryOriginFlag": "../assets/flags/na.svg"
  },
  {
    "id": 151,
    "label": "Nauru",
    "countryCallingCode": "+674",
    "phoneLength": 7,
    "countryCode": "NR",
    "countryOriginFlag": "../assets/flags/nr.svg"
  },
  {
    "id": 152,
    "label": "Nepal",
    "countryCallingCode": "+977",
    "phoneLength": 10,
    "countryCode": "NP",
    "countryOriginFlag": "../assets/flags/np.svg"
  },
  {
    "id": 153,
    "label": "Netherlands",
    "countryCallingCode": "+31",
    "phoneLength": 9,
    "countryCode": "NL",
    "countryOriginFlag": "../assets/flags/nl.svg"
  },
  {
    "id": 154,
    "label": "Netherlands Antilles",
    "countryCallingCode": "+599",
    "phoneLength": 9,
    "countryCode": "AN",
    "countryOriginFlag": "../assets/flags/an.svg"
  },
  {
    "id": 155,
    "label": "New Caledonia",
    "countryCallingCode": "+687",
    "phoneLength": 9,
    "countryCode": "NC",
    "countryOriginFlag": "../assets/flags/nc.svg"
  },
  {
    "id": 156,
    "label": "New Zealand",
    "countryCallingCode": "+64",
    "phoneLength": 9,
    "countryCode": "NZ",
    "countryOriginFlag": "../assets/flags/nz.svg"
  },
  {
    "id": 157,
    "label": "Nicaragua",
    "countryCallingCode": "+505",
    "phoneLength": 8,
    "countryCode": "NI",
    "countryOriginFlag": "../assets/flags/ni.svg"
  },
  {
    "id": 158,
    "label": "Niger",
    "countryCallingCode": "+227",
    "phoneLength": 8,
    "countryCode": "NE",
    "countryOriginFlag": "../assets/flags/ne.svg"
  },
  {
    "id": 159,
    "label": "Nigeria",
    "countryCallingCode": "+234",
    "phoneLength": 10,
    "countryCode": "NG",
    "countryOriginFlag": "../assets/flags/ng.svg"
  },
  {
    "id": 160,
    "label": "Niue",
    "countryCallingCode": "+683",
    "phoneLength": 4,
    "countryCode": "NU",
    "countryOriginFlag": "../assets/flags/nu.svg"
  },
  {
    "id": 161,
    "label": "Norfolk Island",
    "countryCallingCode": "+672",
    "phoneLength": 4,
    "countryCode": "NF",
    "countryOriginFlag": "../assets/flags/nf.svg"
  },
  {
    "id": 162,
    "label": "North Korea",
    "countryCallingCode": "+850",
    "phoneLength": 8,
    "countryCode": "KP",
    "countryOriginFlag": "../assets/flags/kp.svg"
  },
  {
    "id": 163,
    "label": "North Macedonia",
    "countryCallingCode": "+389",
    "phoneLength": 9,
    "countryCode": "MK",
    "countryOriginFlag": "../assets/flags/mk.svg"
  },
  {
    "id": 164,
    "label": "Norway",
    "countryCallingCode": "+47",
    "phoneLength": 8,
    "countryCode": "NO",
    "countryOriginFlag": "../assets/flags/no.svg"
  },
  {
    "id": 165,
    "label": "Oman",
    "countryCallingCode": "+968",
    "phoneLength": 8,
    "countryCode": "OM",
    "countryOriginFlag": "../assets/flags/om.svg"
  },
  {
    "id": 166,
    "label": "Pakistan",
    "countryCallingCode": "+92",
    "phoneLength": 10,
    "countryCode": "PK",
    "countryOriginFlag": "../assets/flags/pk.svg"
  },
  {
    "id": 167,
    "label": "Palau",
    "countryCallingCode": "+680",
    "phoneLength": 7,
    "countryCode": "PW",
    "countryOriginFlag": "../assets/flags/pw.svg"
  },
  {
    "id": 168,
    "label": "Palestine, State of PS",
    "countryCallingCode": "+970",
    "phoneLength": 9,
    "countryCode": "PS",
    "countryOriginFlag": "../assets/flags/ps.svg"
  },
  {
    "id": 169,
    "label": "Panama",
    "countryCallingCode": "+507",
    "phoneLength": 8,
    "countryCode": "PA",
    "countryOriginFlag": "../assets/flags/pa.svg"
  },
  {
    "id": 170,
    "label": "Papua New Guinea",
    "countryCallingCode": "+675",
    "phoneLength": 7,
    "countryCode": "PG",
    "countryOriginFlag": "../assets/flags/pg.svg"
  },
  {
    "id": 171,
    "label": "Paraguay",
    "countryCallingCode": "+595",
    "phoneLength": 9,
    "countryCode": "PY",
    "countryOriginFlag": "../assets/flags/py.svg"
  },
  {
    "id": 172,
    "label": "Peru",
    "countryCallingCode": "+51",
    "phoneLength": 9,
    "countryCode": "PE",
    "countryOriginFlag": "../assets/flags/pe.svg"
  },
  {
    "id": 173,
    "label": "Philippines",
    "countryCallingCode": "+63",
    "phoneLength": 10,
    "countryCode": "PH",
    "countryOriginFlag": "../assets/flags/ph.svg"
  },
  {
    "id": 174,
    "label": "Pitcairn",
    "countryCallingCode": "+64",
    "phoneLength": 9,
    "countryCode": "PN",
    "countryOriginFlag": "../assets/flags/pn.svg"
  },
  {
    "id": 175,
    "label": "Poland",
    "countryCallingCode": "+48",
    "phoneLength": 9,
    "countryCode": "PL",
    "countryOriginFlag": "../assets/flags/pl.svg"
  },
  {
    "id": 176,
    "label": "Portugal",
    "countryCallingCode": "+351",
    "phoneLength": 9,
    "countryCode": "PT",
    "countryOriginFlag": "../assets/flags/pt.svg"
  },
  {
    "id": 177,
    "label": "Puerto Rico",
    "countryCallingCode": "+1",
    "phoneLength": 9,
    "countryCode": "PR",
    "countryOriginFlag": "../assets/flags/pr.svg"
  },
  {
    "id": 178,
    "label": "Qatar",
    "countryCallingCode": "+974",
    "phoneLength": 8,
    "countryCode": "QA",
    "countryOriginFlag": "../assets/flags/qa.svg"
  },
  {
    "id": 179,
    "label": "Republic of Kosovo",
    "countryCallingCode": "+383",
    "phoneLength": 9,
    "countryCode": "XK",
    "countryOriginFlag": "../assets/flags/xk.svg"
  },
  {
    "id": 180,
    "label": "Republic of Moldova",
    "countryCallingCode": "+373",
    "phoneLength": 8,
    "countryCode": "MD",
    "countryOriginFlag": "../assets/flags/md.svg"
  },
  {
    "id": 181,
    "label": "Republic of San Marino",
    "countryCallingCode": "+378",
    "phoneLength": 7,
    "countryCode": "SM",
    "countryOriginFlag": "../assets/flags/sm.svg"
  },
  {
    "id": 182,
    "label": "Republic of the Congo",
    "countryCallingCode": "+242",
    "phoneLength": 9,
    "countryCode": "CG",
    "countryOriginFlag": "../assets/flags/cg.svg"
  },
  {
    "id": 183,
    "label": "Republic of the Marshall Islands",
    "countryCallingCode": "+692",
    "phoneLength": 7,
    "countryCode": "MH",
    "countryOriginFlag": "../assets/flags/mh.svg"
  },
  {
    "id": 184,
    "label": "Réunion",
    "countryCallingCode": "+262",
    "phoneLength": 9,
    "countryCode": "RE",
    "countryOriginFlag": "../assets/flags/re.svg"
  },
  {
    "id": 185,
    "label": "Romania",
    "countryCallingCode": "+40",
    "phoneLength": 9,
    "countryCode": "RO",
    "countryOriginFlag": "../assets/flags/ro.svg"
  },
  {
    "id": 186,
    "label": "Russia",
    "countryCallingCode": "+7",
    "phoneLength": 10,
    "countryCode": "RU",
    "countryOriginFlag": "../assets/flags/ru.svg"
  },
  {
    "id": 187,
    "label": "Rwanda",
    "countryCallingCode": "+250",
    "phoneLength": 9,
    "countryCode": "RW",
    "countryOriginFlag": "../assets/flags/rw.svg"
  },
  {
    "id": 188,
    "label": "Saint Barthélemy",
    "countryCallingCode": "+590",
    "phoneLength": 9,
    "countryCode": "BL",
    "countryOriginFlag": "../assets/flags/bl.svg"
  },
  {
    "id": 189,
    "label": "Saint Helena",
    "countryCallingCode": "+290",
    "phoneLength": 9,
    "countryCode": "SH",
    "countryOriginFlag": "../assets/flags/sh.svg"
  },
  {
    "id": 190,
    "label": "Saint Kitts and Nevis",
    "countryCallingCode": "+1869",
    "phoneLength": 7,
    "countryCode": "KN",
    "countryOriginFlag": "../assets/flags/kn.svg"
  },
  {
    "id": 191,
    "label": "Saint Lucia",
    "countryCallingCode": "+1758",
    "phoneLength": 7,
    "countryCode": "LC",
    "countryOriginFlag": "../assets/flags/lc.svg"
  },
  {
    "id": 192,
    "label": "Saint Martin (French part)",
    "countryCallingCode": "+590",
    "phoneLength": 9,
    "countryCode": "MF",
    "countryOriginFlag": "../assets/flags/mf.svg"
  },
  {
    "id": 193,
    "label": "Saint Pierre and Miquelon",
    "countryCallingCode": "+508",
    "phoneLength": 9,
    "countryCode": "PM",
    "countryOriginFlag": "../assets/flags/pm.svg"
  },
  {
    "id": 194,
    "label": "Saint Vincent and the Grenadines",
    "countryCallingCode": "+1784",
    "phoneLength": 7,
    "countryCode": "VC",
    "countryOriginFlag": "../assets/flags/vc.svg"
  },
  {
    "id": 195,
    "label": "Samoa",
    "countryCallingCode": "+685",
    "phoneLength": 7,
    "countryCode": "WS",
    "countryOriginFlag": "../assets/flags/ws.svg"
  },
  {
    "id": 196,
    "label": "Sao Tome and Principe",
    "countryCallingCode": "+239",
    "phoneLength": 7,
    "countryCode": "ST",
    "countryOriginFlag": "../assets/flags/st.svg"
  },
  {
    "id": 197,
    "label": "Saudi Arabia",
    "countryCallingCode": "+966",
    "phoneLength": 10,
    "countryCode": "SA",
    "countryOriginFlag": "../assets/flags/sa.svg"
  },
  {
    "id": 198,
    "label": "Senegal",
    "countryCallingCode": "+221",
    "phoneLength": 8,
    "countryCode": "SN",
    "countryOriginFlag": "../assets/flags/sn.svg"
  },
  {
    "id": 199,
    "label": "Serbia",
    "countryCallingCode": "+381",
    "phoneLength": 9,
    "countryCode": "RS",
    "countryOriginFlag": "../assets/flags/rs.svg"
  },
  {
    "id": 200,
    "label": "Seychelles",
    "countryCallingCode": "+248",
    "phoneLength": 7,
    "countryCode": "SC",
    "countryOriginFlag": "../assets/flags/sc.svg"
  },
  {
    "id": 201,
    "label": "Sierra Leone",
    "countryCallingCode": "+232",
    "phoneLength": 8,
    "countryCode": "SL",
    "countryOriginFlag": "../assets/flags/sl.svg"
  },
  {
    "id": 202,
    "label": "Singapore",
    "countryCallingCode": "+65",
    "phoneLength": 8,
    "countryCode": "SG",
    "countryOriginFlag": "../assets/flags/sg.svg"
  },
  {
    "id": 203,
    "label": "Sint Maarten (Dutch part)",
    "countryCallingCode": "+1721",
    "phoneLength": 7,
    "countryCode": "SX",
    "countryOriginFlag": "../assets/flags/sx.svg"
  },
  {
    "id": 204,
    "label": "Slovakia",
    "countryCallingCode": "+421",
    "phoneLength": 9,
    "countryCode": "SK",
    "countryOriginFlag": "../assets/flags/sk.svg"
  },
  {
    "id": 205,
    "label": "Slovenia",
    "countryCallingCode": "+386",
    "phoneLength": 8,
    "countryCode": "SI",
    "countryOriginFlag": "../assets/flags/si.svg"
  },
  {
    "id": 206,
    "label": "Solomon Islands",
    "countryCallingCode": "+677",
    "phoneLength": 7,
    "countryCode": "SB",
    "countryOriginFlag": "../assets/flags/sb.svg"
  },
  {
    "id": 207,
    "label": "Somalia",
    "countryCallingCode": "+252",
    "phoneLength": 8,
    "countryCode": "SO",
    "countryOriginFlag": "../assets/flags/so.svg"
  },
  {
    "id": 208,
    "label": "South Africa",
    "countryCallingCode": "+27",
    "phoneLength": 9,
    "countryCode": "ZA",
    "countryOriginFlag": "../assets/flags/za.svg"
  },
  {
    "id": 209,
    "label": "South Georgia and the South Sandwich Islands",
    "countryCallingCode": "+500",
    "phoneLength": 9,
    "countryCode": "GS",
    "countryOriginFlag": "../assets/flags/gs.svg"
  },
  {
    "id": 210,
    "label": "South Korea",
    "countryCallingCode": "+82",
    "phoneLength": 10,
    "countryCode": "KR",
    "countryOriginFlag": "../assets/flags/kr.svg"
  },
  {
    "id": 211,
    "label": "South Sudan",
    "countryCallingCode": "+211",
    "phoneLength": 9,
    "countryCode": "SS",
    "countryOriginFlag": "../assets/flags/ss.svg"
  },
  {
    "id": 212,
    "label": "Spain",
    "countryCallingCode": "+34",
    "phoneLength": 9,
    "countryCode": "ES",
    "countryOriginFlag": "../assets/flags/es.svg"
  },
  {
    "id": 213,
    "label": "Sri Lanka",
    "countryCallingCode": "+94",
    "phoneLength": 10,
    "countryCode": "LK",
    "countryOriginFlag": "../assets/flags/lk.svg"
  },
  {
    "id": 214,
    "label": "Sudan",
    "countryCallingCode": "+249",
    "phoneLength": 9,
    "countryCode": "SD",
    "countryOriginFlag": "../assets/flags/sd.svg"
  },
  {
    "id": 215,
    "label": "Suriname",
    "countryCallingCode": "+597",
    "phoneLength": 7,
    "countryCode": "SR",
    "countryOriginFlag": "../assets/flags/sr.svg"
  },
  {
    "id": 216,
    "label": "Svalbard and Jan Mayen",
    "countryCallingCode": "+4779",
    "phoneLength": 9,
    "countryCode": "SJ",
    "countryOriginFlag": "../assets/flags/sj.svg"
  },
  {
    "id": 217,
    "label": "Sweden",
    "countryCallingCode": "+46",
    "phoneLength": 9,
    "countryCode": "SE",
    "countryOriginFlag": "../assets/flags/se.svg"
  },
  {
    "id": 218,
    "label": "Switzerland",
    "countryCallingCode": "+41",
    "phoneLength": 9,
    "countryCode": "CH",
    "countryOriginFlag": "../assets/flags/ch.svg"
  },
  {
    "id": 219,
    "label": "Syrian Arab Republic",
    "countryCallingCode": "+963",
    "phoneLength": 9,
    "countryCode": "SY",
    "countryOriginFlag": "../assets/flags/sy.svg"
  },
  {
    "id": 220,
    "label": "Taiwan, Province of China",
    "countryCallingCode": "+886",
    "phoneLength": 9,
    "countryCode": "TW",
    "countryOriginFlag": "../assets/flags/tw.svg"
  },
  {
    "id": 221,
    "label": "Tajikistan",
    "countryCallingCode": "+992",
    "phoneLength": 9,
    "countryCode": "TJ",
    "countryOriginFlag": "../assets/flags/tj.svg"
  },
  {
    "id": 222,
    "label": "Territory of Heard Island and McDonald Islands",
    "countryCallingCode": "+672",
    "phoneLength": 9,
    "countryCode": "HM",
    "countryOriginFlag": "../assets/flags/hm.svg"
  },
  {
    "id": 223,
    "label": "Thailand",
    "countryCallingCode": "+66",
    "phoneLength": 9,
    "countryCode": "TH",
    "countryOriginFlag": "../assets/flags/th.svg"
  },{
    "id": 224,
    "label": "Timor-Leste",
    "countryCallingCode": "+670",
    "phoneLength": 7,
    "countryCode": "TL",
    "countryOriginFlag": "../assets/flags/tl.svg"
  },
  {
    "id": 225,
    "label": "Togo",
    "countryCallingCode": "+228",
    "phoneLength": 8,
    "countryCode": "TG",
    "countryOriginFlag": "../assets/flags/tg.svg"
  },
  {
    "id": 226,
    "label": "Tokelau",
    "countryCallingCode": "+690",
    "phoneLength": 9,
    "countryCode": "TK",
    "countryOriginFlag": "../assets/flags/tk.svg"
  },
  {
    "id": 227,
    "label": "Tonga",
    "countryCallingCode": "+676",
    "phoneLength": 7,
    "countryCode": "TO",
    "countryOriginFlag": "../assets/flags/to.svg"
  },
  {
    "id": 228,
    "label": "Trinidad and Tobago",
    "countryCallingCode": "+1-868",
    "phoneLength": 7,
    "countryCode": "TT",
    "countryOriginFlag": "../assets/flags/tt.svg"
  },
  {
    "id": 229,
    "label": "Tunisia",
    "countryCallingCode": "+216",
    "phoneLength": 8,
    "countryCode": "TN",
    "countryOriginFlag": "../assets/flags/tn.svg"
  },
  {
    "id": 230,
    "label": "Turkey",
    "countryCallingCode": "+90",
    "phoneLength": 10,
    "countryCode": "TR",
    "countryOriginFlag": "../assets/flags/tr.svg"
  },
  {
    "id": 231,
    "label": "Turkmenistan",
    "countryCallingCode": "+993",
    "phoneLength": 9,
    "countryCode": "TM",
    "countryOriginFlag": "../assets/flags/tm.svg"
  },
  {
    "id": 232,
    "label": "Turks and Caicos Islands",
    "countryCallingCode": "+1649",
    "phoneLength": 9,
    "countryCode": "TC",
    "countryOriginFlag": "../assets/flags/tc.svg"
  },
  {
    "id": 233,
    "label": "Tuvalu",
    "countryCallingCode": "+688",
    "phoneLength": 7,
    "countryCode": "TV",
    "countryOriginFlag": "../assets/flags/tv.svg"
  },
  {
    "id": 234,
    "label": "Uganda",
    "countryCallingCode": "+256",
    "phoneLength": 9,
    "countryCode": "UG",
    "countryOriginFlag": "../assets/flags/ug.svg"
  },
  {
    "id": 235,
    "label": "Ukraine",
    "countryCallingCode": "+380",
    "phoneLength": 9,
    "countryCode": "UA",
    "countryOriginFlag": "../assets/flags/ua.svg"
  },
  {
    "id": 236,
    "label": "United Kingdom",
    "countryCallingCode": "+44",
    "phoneLength": 10,
    "countryCode": "GB",
    "countryOriginFlag": "../assets/flags/gb.svg"
  },
  {
    "id": 237,
    "label": "United Republic of Tanzania",
    "countryCallingCode": "+255",
    "phoneLength": 9,
    "countryCode": "TZ",
    "countryOriginFlag": "../assets/flags/tz.svg"
  },
  {
    "id": 238,
    "label": "United States Minor Outlying Islands",
    "countryCallingCode": "+1",
    "phoneLength": 10,
    "countryCode": "UM",
    "countryOriginFlag": "../assets/flags/um.svg"
  },
  {
    "id": 239,
    "label": "United States of America",
    "countryCallingCode": "+1",
    "phoneLength": 9,
    "countryCode": "US",
    "countryOriginFlag": "../assets/flags/us.svg"
  },
  {
    "id": 240,
    "label": "Uruguay",
    "countryCallingCode": "+598",
    "phoneLength": 8,
    "countryCode": "UY",
    "countryOriginFlag": "../assets/flags/uy.svg"
  },
  {
    "id": 241,
    "label": "Uzbekistan",
    "countryCallingCode": "+998",
    "phoneLength": 9,
    "countryCode": "UZ",
    "countryOriginFlag": "../assets/flags/uz.svg"
  },
  {
    "id": 242,
    "label": "Vanuatu",
    "countryCallingCode": "+678",
    "phoneLength": 7,
    "countryCode": "VU",
    "countryOriginFlag": "../assets/flags/vu.svg"
  },
  {
    "id": 243,
    "label": "Venezuela (Bolivarian Republic of)",
    "countryCallingCode": "+58",
    "phoneLength": 10,
    "countryCode": "VE",
    "countryOriginFlag": "../assets/flags/ve.svg"
  },
  {
    "id": 244,
    "label": "Vietnam",
    "countryCallingCode": "+84",
    "phoneLength": 9,
    "countryCode": "VN",
    "countryOriginFlag": "../assets/flags/vn.svg"
  },
  {
    "id": 245,
    "label": "Virgin Islands (British)",
    "countryCallingCode": "+1284",
    "phoneLength": 9,
    "countryCode": "VG",
    "countryOriginFlag": "../assets/flags/vg.svg"
  },
  {
    "id": 246,
    "label": "Virgin Islands (U.S.)",
    "countryCallingCode": "+1340",
    "phoneLength": 9,
    "countryCode": "VI",
    "countryOriginFlag": "../assets/flags/vi.svg"
  },
  {
    "id": 247,
    "label": "Wallis and Futuna",
    "countryCallingCode": "+681",
    "phoneLength": 9,
    "countryCode": "WF",
    "countryOriginFlag": "../assets/flags/wf.svg"
  },
  {
    "id": 248,
    "label": "Western Sahara",
    "countryCallingCode": "+212",
    "phoneLength": 9,
    "countryCode": "EH",
    "countryOriginFlag": "../assets/flags/eh.svg"
  },
  {
    "id": 249,
    "label": "Yemen",
    "countryCallingCode": "+967",
    "phoneLength": 9,
    "countryCode": "YE",
    "countryOriginFlag": "../assets/flags/ye.svg"
  },
  {
    "id": 250,
    "label": "Zambia",
    "countryCallingCode": "+260",
    "phoneLength": 9,
    "countryCode": "ZM",
    "countryOriginFlag": "../assets/flags/zm.svg"
  },
  {
    "id": 251,
    "label": "Zimbabwe",
    "countryCallingCode": "+263",
    "phoneLength": 9,
    "countryCode": "ZW",
    "countryOriginFlag": "../assets/flags/zw.svg"
  }
];

// Four entries above carry non-ITU calling codes that the lookup-by-
// countryCallingCode design uses as unique identifiers (e.g. `+61891` for
// Cocos vs `+61` for Australia). The values in this map are what the user
// should SEE in the picker; the stored value still uses the unique
// non-ITU code until pickers are refactored to bind by `country.id`.
export const COUNTRY_DISPLAY_CODE_OVERRIDES: Record<string, string> = {
  "+61891": "+61",
  "+5997": "+599",
  "+4779": "+47",
  "+1-868": "+1868",
};

// Format a country's `countryCallingCode` for display in a picker option,
// applying the overrides above. Returns e.g. `(+971)`, `(+1684)`, `(+61)`
// (Cocos collapsed to AU's ITU code).
// Wrapped in LRI…PDI (U+2066/U+2069) so RTL layouts keep the logical order —
// without it the bidi algorithm renders "(+213)" as "(213+)".
export const formatCallingCode = (code: string): string => {
  const display = COUNTRY_DISPLAY_CODE_OVERRIDES[code] ?? code;
  return `⁦(+${display.replace("+", "")})⁩`;
};
